import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../utils/formatCurrency';
import { formatPeriod, formatShortDate } from '../../utils/partnerPortal';

/**
 * Historial de liquidaciones mensuales del partner (RES-93).
 */
function PartnerPayoutsTable({ payouts = [], locale }) {
  const { t } = useTranslation();

  return (
    <section className="pp-card" aria-labelledby="pp-payouts-title">
      <h2 id="pp-payouts-title" className="pp-card-title">
        {t('partnerPortal.payouts.title')}
      </h2>
      {payouts.length === 0 ? (
        <p className="pp-empty" data-testid="pp-payouts-empty">
          {t('partnerPortal.payouts.empty')}
        </p>
      ) : (
        <div className="pp-table-wrap">
          <table className="pp-table" data-testid="pp-payouts">
            <thead>
              <tr>
                <th scope="col">{t('partnerPortal.payouts.period')}</th>
                <th scope="col" className="pp-num">
                  {t('partnerPortal.payouts.locations')}
                </th>
                <th scope="col" className="pp-num">
                  {t('partnerPortal.payouts.pct')}
                </th>
                <th scope="col" className="pp-num">
                  {t('partnerPortal.payouts.gross')}
                </th>
                <th scope="col" className="pp-num">
                  {t('partnerPortal.payouts.payable')}
                </th>
                <th scope="col">{t('partnerPortal.payouts.status')}</th>
                <th scope="col">{t('partnerPortal.payouts.date')}</th>
              </tr>
            </thead>
            <tbody>
              {payouts.map((p) => (
                <tr key={p.period}>
                  <td>{formatPeriod(p.period)}</td>
                  <td className="pp-num">{p.activeLocations ?? '—'}</td>
                  <td className="pp-num">
                    {p.commissionPct !== undefined && p.commissionPct !== null
                      ? `${p.commissionPct}%`
                      : '—'}
                  </td>
                  <td className="pp-num">
                    {formatCurrency(p.grossTotal)}
                    {Number(p.signOnBonus) > 0 && (
                      <span className="pp-sub">
                        {t('partnerPortal.payouts.includesBonus', {
                          amount: formatCurrency(p.signOnBonus),
                        })}
                      </span>
                    )}
                    {Number(p.rolloverIn) > 0 && (
                      <span className="pp-sub">
                        {t('partnerPortal.payouts.includesRollover', {
                          amount: formatCurrency(p.rolloverIn),
                        })}
                      </span>
                    )}
                  </td>
                  <td className="pp-num">{formatCurrency(p.payableAmount)}</td>
                  <td>
                    <span className={`pp-badge pp-payout--${p.status}`} data-status={p.status}>
                      {t(`partnerPortal.payoutStatus.${p.status}`)}
                    </span>
                  </td>
                  <td>
                    {p.status === 'paid'
                      ? formatShortDate(p.paidAt, locale) || '—'
                      : p.status === 'rollover'
                        ? t('partnerPortal.payouts.rolledOver')
                        : formatShortDate(p.estimatedDate, locale) || '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}

export default PartnerPayoutsTable;
